import { defineMessage } from 'services/localization';

export const messages = {
    pay: defineMessage('pay_amount'),
    payInfo: defineMessage('you_are_paying_amount_for_the_friendlyname'),
    payNow: defineMessage('pay_now'),
    schedulePayment: defineMessage('schedule_payment'),
};
